import React from 'react';
import { Button, refreshPreloadedAssets } from '@meu-mapa-nev/design-system';

import { AlertComFoco } from './AlertComFoco.js';

/** Mantém uma falha de carregamento restrita à área, com recuperação explícita. */
export class AreaBoundary extends React.Component<
  React.PropsWithChildren,
  { failed: boolean; refreshing: boolean }
> {
  override state = { failed: false, refreshing: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (this.state.failed) {
      return (
        <section>
          <AlertComFoco type="critical" title="Área indisponível">
            Não foi possível carregar esta área. Verifique a conexão e atualize a página.
          </AlertComFoco>
          <Button
            type="button"
            disabled={this.state.refreshing}
            aria-busy={this.state.refreshing}
            onClick={() => {
              this.setState({ refreshing: true });
              void refreshPreloadedAssets().finally(() => window.location.reload());
            }}
          >
            {this.state.refreshing ? 'Atualizando…' : 'Atualizar página'}
          </Button>
        </section>
      );
    }
    return this.props.children;
  }
}
